import axios from "axios";
const BaseURL = process.env.REACT_APP_API_PATH;

export const getCandidateById = async (id) => {
    const res = await axios.get(`${BaseURL}/ebench/get_Candidate?id=${id}`);
    return res.data?.data; // return only needed data
};

export const getVendorById = async (id) => {
    const res = await axios.get(`${BaseURL}/ebench/get_vendor_by_vendorId?vendorId=${id}`);
    return res.data?.data;
};
